<strong>
  <span class="text-bold">Copyright &copy; {{ currentYear }} </span>
  <a href="https://varnik.cloud/" rel="noopener noreferrer" class="text-decoration-none" target="_blank">VarNik Systems Services Pvt Ltd</a>
  <span>.</span>
</strong>
<span class="text-bold"> All rights reserved.</span>
